export default __webpack_public_path__ + "static/media/Dentistry.787b9a7e.png";